import { InvoiceDto } from "@/types/api/api-types";

export type InvoiceTableState = {
  filters: {
    searchField: string;
  };
  modals: {
    selectedInvoice: InvoiceDto | null;
    statusEditInvoice: InvoiceDto | null;
  };
};

export type InvoiceTableAction =
  | {
      type: "SET_FILTER";
      field: keyof InvoiceTableState["filters"];
      value: any;
    }
  | { type: "SET_MODAL"; field: keyof InvoiceTableState["modals"]; value: any }
  | { type: "RESET_FILTERS" }
  | { type: "CLOSE_ALL_MODALS" };

export const initialState: InvoiceTableState = {
  filters: {
    searchField: "",
  },
  modals: {
    selectedInvoice: null,
    statusEditInvoice: null,
  },
};

export function blockedInvoiceTableReducer(
  state: InvoiceTableState,
  action: InvoiceTableAction,
): InvoiceTableState {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.field]: action.value,
        },
      };
    case "SET_MODAL":
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.field]: action.value,
        },
      };
    case "RESET_FILTERS":
      return {
        ...state,
        filters: initialState.filters,
      };
    case "CLOSE_ALL_MODALS":
      return {
        ...state,
        modals: initialState.modals,
      };
    default:
      return state;
  }
}

export const createFilterAction = (
  field: keyof InvoiceTableState["filters"],
  value: any,
): InvoiceTableAction => ({
  type: "SET_FILTER",
  field,
  value,
});

export const createModalAction = (
  field: keyof InvoiceTableState["modals"],
  value: any,
): InvoiceTableAction => ({
  type: "SET_MODAL",
  field,
  value,
});
